export default {
  edit (aModel) {
    this.editRelation('roles', aModel)
  },

  delete (aModel) {
    this.deleteRelation('roles', aModel)
  }
}



// WEBPACK FOOTER //
// ./src/functions/roles.js